import { useMutation } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

/**
 * This is to track the download excel bid template query key in react query cache.
 */
const DOWNLOAD_EXCEL_BID_TEMPLATE_MUTATION_KEY =
  'download-bid-book-template-key';

interface IUseDownloadBidTemplateMutationPayload {
  bidValidityConfigId?: string;
  brandIds?: string[];
  categoryId: string;
  groupIds?: string[];
  onSuccess?: (fileData: BlobPart) => void;
}

/**
 * This custom query hook is used to download the bid file template in excel format.
 * `useDownloadBidBookMutation` is also used to download the bid book in excel format,
 * but is an older implementation.
 */
export const useDownloadBidTemplateMutation = ({
  bidValidityConfigId,
  brandIds,
  categoryId,
  groupIds,
  onSuccess,
}: IUseDownloadBidTemplateMutationPayload) => {
  const {
    isPending,
    isError,
    error,
    data,
    mutate: downloadBidTemplate,
  } = useMutation({
    mutationKey: [
      DOWNLOAD_EXCEL_BID_TEMPLATE_MUTATION_KEY,
      bidValidityConfigId,
      brandIds,
      categoryId,
      groupIds,
    ],
    networkMode: 'always',
    mutationFn: () =>
      BIDS_API.downloadBidFileTemplate({
        bidValidityConfigId,
        brandIds,
        categoryId,
        groupIds,
      }),
    onSuccess,
  });

  return {
    error,
    isError,
    data,
    downloadBidTemplate,
    /**
     * NOTE: For disabled query isLoading is set to true by default which
     * causes discrepancies. So this solution works as per the official docs.
     */
    isPending,
  };
};
